import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "children", "content", "referenceRef", "placement", "offset", "distance", "arrowSize", "positionFixed", "adaptivePositioning", "matchReferenceWidth"];
import React, { forwardRef } from 'react';
import PopoverCard from 'components/PopoverCard';
import usePopover from 'hooks/usePopover';
var Popover = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var as = _ref.as,
    children = _ref.children,
    content = _ref.content,
    referenceRef = _ref.referenceRef,
    placement = _ref.placement,
    offset = _ref.offset,
    distance = _ref.distance,
    arrowSize = _ref.arrowSize,
    positionFixed = _ref.positionFixed,
    adaptivePositioning = _ref.adaptivePositioning,
    matchReferenceWidth = _ref.matchReferenceWidth,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var popover = usePopover({
    ref: ref,
    referenceRef: referenceRef,
    placement: placement,
    offset: offset,
    distance: distance,
    arrowSize: arrowSize,
    positionFixed: positionFixed,
    adaptivePositioning: adaptivePositioning,
    matchReferenceWidth: matchReferenceWidth
  });
  return (
    /*#__PURE__*/
    /*
     Warning!!! `PopoverCard` is currently not being properly typechecked.
     Comment out `otherProps` and `as` when making changes to check types 
    */
    React.createElement(React.Fragment, null, children({
      ref: popover.setReferenceRef,
      update: popover.update
    }), /*#__PURE__*/React.createElement(PopoverCard, _extends({}, otherProps, {
      as: as || 'div'
    }, popover.props, {
      ref: popover.setRef,
      arrow: popover.arrow
    }), content))
  );
});
Popover.displayName = 'Popover';
export default Popover;